import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, PropType, computed, watch } from 'vue'
import { snakeCase } from 'lodash'
import { useInitDataStore } from '@/stores/initDataStore'
import { GraphTypeField } from '@/lib/graph/types/graphData'
import MultiSelectModal, { Option } from '@/components/common/MultiSelectModal.vue'
import { StationListItem } from '@/models/InitData'


export default /*#__PURE__*/_defineComponent({
  props: {
  modal: Boolean,
  stations: Array as PropType<StationListItem[]>,
  field: Object as PropType<GraphTypeField>,
},
  emits: ['update:stations', 'update:modal'],
  setup(__props, { emit }) {

const props = __props

const MAX_SELECT_NUM = 8


const initDataStore = useInitDataStore()
const selected = ref<Option[]>(props.stations?.map(s => ({ value: s.stationId, label: s.name })) || [])

const stationList = computed(() => {
  if (!props.field) {
    return []
  }

  const list = initDataStore.initData.stationList
  const field = snakeCase(props.field.selectedId).split('_').includes('water') ? 'water' : 'rain'

  // 選択中のグラフタイプが有効な局のみ選択肢に表示
  return list.filter(s => s.fieldId.some(f => f.includes(field)))
})

const modal = computed({
  get() {
    return props.modal
  },
  set(modal) {
    emit('update:modal', modal)
  },
})

const options = computed(() => {
  return stationList.value.map(s => ({ value: s.stationId, label: s.name }))
})

const emptyMessage = computed(() => {
  return `${props.field?.title}に対応する観測地が存在しません`
})

watch(
  () => selected.value,
  () => {
    const selectedStations = selected.value
      .map(s => {
        const station = stationList.value.find(sl => sl.stationId === s.value)

        if (station === undefined) {
          return
        }

        return { ...station, color: s.color }
      })
      .filter(s => s)

    emit('update:stations', selectedStations)
  }
)

watch(
  () => stationList.value,
  () => {
    selected.value = stationList.value.slice(0, 8).map(s => ({ value: s.stationId, label: s.name }))
  },
  { immediate: true }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(MultiSelectModal, {
    modal: _unref(modal),
    "onUpdate:modal": _cache[0] || (_cache[0] = ($event: any) => (_isRef(modal) ? (modal).value = $event : null)),
    selected: selected.value,
    "onUpdate:selected": _cache[1] || (_cache[1] = ($event: any) => ((selected).value = $event)),
    options: _unref(options),
    maxSelectNum: MAX_SELECT_NUM,
    emptyMessage: _unref(emptyMessage)
  }, null, 8, ["modal", "selected", "options", "emptyMessage"]))
}
}

})